import LevelData from "./LevelData";
import Game from "./scenes/Game";
import Level from "./scenes/Level";
import Title from "./scenes/Title";

export default {
  /**
   * Add your scene classes here. Simply put the scene class.
   * Ex: `scenes: [MyScene,MyOtherScene]`
   * @type {{KEY:string}[]}
   */
  scenes: [Title, Level, Game],

  /**
   * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
   * It is recommended you put `MyScene.KEY` here instead of using a string.
   * @type {string}
   */
  startScene: Title.KEY,
  levelData: new LevelData(),
  isMuted: false,
};
